<template>
  <div>
    <!--class="gray" 代表灰度模式，卡失效-->
    <div :class="`care-card ${size} ${care && care.status != 20?'gray':''} ${isShowRenew?'renew':''}`" @click="() => onClick && onClick(care)">
      <div class="inner">
        <div class="content" v-if="care">
          <div class="c-info">
            <div class="row name">
              <div class="title">{{ care.name }}</div>
              <div v-if="care.status" class="status">
                <span>{{ statusMapper(care.status, care.audit) }}</span>
              </div>
            </div>
            <div v-if="care.imei" class="row imei">
              {{ "IMEI码 "+ care.imei }}
            </div>
            <div class="info-line" v-if="care.status == 100 || care.status == -10">
              <span>{{statusMapper(care.status, care.audit)}}</span>
            </div>
            <div class="info-line" v-else>
              <template v-if="care.canRenew"> <!--当前可续费卡显示倒计时-->
                <countdown :time="care.endTime" class="date"></countdown>
              </template>
              <template v-else>
                <span>部分权益有效期至</span>
                <span class="date">{{care.endTime ?  care.endTime.format("yyyy年MM月dd日") : '激活之日起'+ care.effectiveDay +'天' }}</span>
              </template>
            </div>
            <div class="card-ico">
              <!--todo：卡图标从服务端动态取-->
              <img :src="care.img || require('@/assets/card-ico.png')" />
            </div>
          </div>
          <div class="renew" v-if="isShowRenew">
            <div class="r-l">
              <span class="title">{{care.maxMonth}}个月</span>
              <span>续费后最长延长服务</span>
            </div>
            <div class="line"></div>
            <div class="r-r">
              <span class="title">{{care.minAvg}}元/月</span>
              <span>一次性续费最低折合</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "CareCard",
  props: {
    care: {
      type: Object,
    },
    onClick: {
      type: Function,
    },
      //尺寸大小：big/small
    size:{
      type:String,
      default:'small'
    },
      //是否展示续费信息
      isShowRenew:{
        type:Boolean,
        default: false
      }
  },
  methods: {
    //status: 10= 未激活，20=已激活，-10=已失效，-20=已作废，100=已履约
    //audit: -1=未提交审核，10=待审核，20=审核通过，30=审核失败
    statusMapper(status, audit) {
      switch (parseInt(status)) {
        case 10:
          var text = "未激活";
          var auditStatus = parseInt(audit);
          if(auditStatus == 10)
          {
             text = "等待客服激活";
          }
          else if(auditStatus == 30)
          {
             text = "激活失败";
          }
          return text;
        case 20:
          return "保障中";
        case -10:
          return "已失效";
        case -20:
          return "已作废";
          case 100:
              return "已履约";
      }
    },
  },
};
</script>

<style lang="less" scoped>
.care-card {
  background-size: 102% 102%;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  background: linear-gradient(270deg,#323232, #000000);
  color: #fff;
  &.big{
    .inner{
      height: 188px;
      .content{
        .name{
          .title{
            font-size: 20px;
          }
        }
        .status{
          font-size: 12px;
          span{
            padding: 3px 5px;
          }
        }
        .imei{
          display: block !important;
        }
        .info-line{
          bottom: 30px !important;
        }
        .card-ico{
          width: 72px !important;
          height: 82px !important;
        }
      }
    }
  }
  &.gray{
    .card-ico>img{
      -webkit-filter: grayscale(100%);
      -moz-filter: grayscale(100%);
      -ms-filter: grayscale(100%);
      -o-filter: grayscale(100%);
      filter: grayscale(100%);
      filter: gray;
    }
  }
  &.renew{
    .inner{
      height: 233px;
      .content{
        .info-line{
          bottom: 100px !important;
        }
        .card-ico{
          bottom: 80px !important;
        }
      }
    }
  }
  .inner {
    height: 137px;
    position: relative;
    .content {
      position: absolute;
      top: 6px;
      left: 6px;
      right: 6px;
      bottom: 6px;
      box-sizing: border-box;
      border: 1px solid rgba(239,216,190,0.6);
      border-radius: 8px;
      overflow: hidden;
      transform: rotate(0deg);
      .c-info{
        padding: 20px 16px 0 16px;
        .info-line{
          position: absolute;
          left: 16px;
          bottom: 10px;
          display: flex;
          flex-direction: column;
          font-size: 11px;
          .date{
            font-weight: 600;
            font-size: 13px;
            margin-top: 3px;
            i{
              font-style: normal;
              display: inline-block;
              width: 18px;
              height: 18px;
              text-align: center;
              line-height: 18px;
              background: #e2e2e2;
              border-radius: 2px;
              color: #000;
              margin: 0 2px;
            }
          }
        }
        .card-ico{
          position: absolute;
          right: 16px;
          bottom: 10px;
          width: 61px;
          height: 71px;
          text-align: center;
          img{
            display: inline-block;
            width: 100%;
            height: 100%;
          }
        }
        .imei{
          display: none;
          margin-top: 15px;
          color: #F3DBBF;
          font-size: 11px;
        }
      }
      .renew{
        background-color: #000;
        padding: 20px 0;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        position: absolute;
        bottom: 0;
        width: 100%;
        .r-l,.r-r{
          display: flex;
          flex-direction: column;
          font-size: 11px;
          text-align: center;
          box-sizing: border-box;
          width: 49%;
          .title{
            font-size: 13px;
            font-weight: 600;
            color: #ffe1b7;
          }
        }
        .line{
          width: 1px;
          background-color: #4f4f4f;
        }
      }
    }
  }
  .row {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .name {
    height: 16px;
    .title {
      font-size: 16px;
      margin-right: 8px;
      margin-left: 2px;
      color: #f3dbbf;
      font-weight: 600;
    }
  }
  .status {
    color: #ffe7c2;
    border-radius: 5px 0 5px 0;
    padding: 2px 8px;
    font-size: 10px;
    margin-left: 4px;
    span{
      display: inline-block;
      background: linear-gradient(90deg,rgba(246,227,203,0.4), rgba(210,177,145,0.4));
      border-radius: 6px 0px 6px 0px;
      padding: 1px 3px;
    }
  }
  .button:active::before {
    display: block;
    content: "";
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    border-radius: 13px;
    background: rgba(0, 0, 0, 5%);
  }
}
</style>
